import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { HubLoComponent } from './hub-lo.component';
import { HubLoAccountSelectorStepComponent } from './steps/account-selector-step/account-selector-step.component';
import { HubLoRevokeStepComponent } from './steps/revoke-step/revoke-step.component';
import { HubLoRevokeConfirmationStepComponent } from './steps/revoke-confirmation-step/revoke-confirmation-step.component';
import { HubLoResultStepComponent } from './steps/result-step/result-step.component';
import { HubLoAuthorizationIntroStepComponent } from './steps/authorization-intro-step/authorization-intro-step.component';
import { TrCheckboxModule } from '@toro/common/shared/components/tr-forms-inputs/tr-checkbox/tr-checkbox.module';
import { SvgIconModule } from '../svg-icon/svg-icon.module';
import { HubAuthorizationHeaderModule } from '../hub-authorization/components/header/hub-authorization-header.module';
import { HubLoDeleteAccountComponent } from './steps/delete-bank-step/delete-account-step.component';
import { TrSpinnerModule } from '../tr-spinner/tr-spinner.module';

@NgModule({
  imports: [CommonModule, TrCheckboxModule, SvgIconModule, HubAuthorizationHeaderModule, TrSpinnerModule],
  declarations: [
    HubLoComponent,
    HubLoAuthorizationIntroStepComponent,
    HubLoAccountSelectorStepComponent,
    HubLoRevokeStepComponent,
    HubLoRevokeConfirmationStepComponent,
    HubLoResultStepComponent,
    HubLoDeleteAccountComponent,
  ],
  exports: [HubLoComponent],
})
export class HubLoModule {}
